import axios from "axios";

export const post = (data, path) =>
  axios
    .post(`${window.location.protocol}//${window.location.host}/api/${path}`, data)
    .then(response => response.data)



// WEBPACK FOOTER //
// ./src/utils/api.js